import { Sorting } from 'src/common/components/Filters/constants/sorting';
import { useSimInventoryFetch } from 'simInventory/hooks/useSimInventoryFetch';
import { SimInventoryFiltersV2 } from 'simInventory/models/SimProfile.model';

export const useSimInventory = (
  filters: SimInventoryFiltersV2,
  sort: { columnName: string; sort: Sorting } | null,
  rowsPerPage: number,
  page: number,
) => {
  const {
    simInventory,
    isRefetching,
    pagination: { totalNumberOfItems },
  } = useSimInventoryFetch(filters, sort, rowsPerPage, page);

  return {
    pagination: {
      totalNumberOfItems,
    },
    simInventory,
    isRefetching,
  };
};
